// services/purchases/DebitNoteLookupService.ts
import { CreditNoteLookupFilter, SelectOption } from '../../types/purchases/CreditNoteLookup';
import { ApiResponse } from '../../types/common/ApiResponse';
import { debitNoteLookupApi } from '../../api';

const DebitNoteLookupService = {
  /**
   * POST /api/debit-note-lookup/purchases/search
   */
  searchEligiblePurchases: async (
    filters: CreditNoteLookupFilter
  ): Promise<ApiResponse<SelectOption[]>> => {
    const response = await debitNoteLookupApi.addCustom('/purchases/search', filters);
    return response.data;
  },

  /**
   * GET /api/debit-note-lookup/products/{purchaseId}
   */
  getProductsByPurchase: async (
    purchaseId: number
  ): Promise<ApiResponse<SelectOption[]>> => {
    const response = await debitNoteLookupApi.fetchCustom(`/products/${purchaseId}`);
    return response.data;
  },
};

export default DebitNoteLookupService;
